import { BadgeType } from "components/atoms/Badge/Badge";

const ShipmentStatusColors: Record<string, BadgeType> = {
  "In transit": "tertiary",
  Incomplete: "warning",
  Delayed: "danger",
  Archive: "secondary",
  Delivered: "primary",
  Booked: "secondary",
  Canceled: "secondary",
  "Auto-closed": "secondary",
};

export default ShipmentStatusColors;
